<div class="kpi-item">
    <div class="tooltip-container">
        <achoo-icon-tooltip [tooltipMsg]="titleTooltip"></achoo-icon-tooltip>
    </div>
    <div class="kpi-info">
        <!-- <span class="kpi-value" *ngIf="!isPercentValue">{{kpi.value | thousandNumberSuffix}}</span>
        <span class="kpi-value" *ngIf="isPercentValue">{{ kpi.value | percentNumberSuffix:1 }}</span>
        <span class="kpi-name">{{kpi.name}}</span> -->

        <span class="kpi-value" *ngIf="!isPercentValue">- K</span>
        <span class="kpi-value" *ngIf="isPercentValue">- %</span>
        <span class="kpi-name">{{name}}</span>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/main/influencer/new-kpi/new-kpi-item-placeholder/new-kpi-item-placeholder.component.html